import {
  IS_REQUIRED,
  TIME_IS_REQUIRED,
  DRIVER_FORM_ENTITIES,
  INVALID_SHORT_TIME_FORMAT,
} from '../../constants/strings';
import {
  HHMM_TIME_FORMAT,
  getDiffInMinutes,
  isInvalidStopTime,
} from '../../utils/date';

export const validateDriverName = (value) => {
  if (!value || !value.trim()) {
    return `${DRIVER_FORM_ENTITIES.DRIVER_NAME} ${IS_REQUIRED}`;
  }
  if (value.length > 50) {
    return "Driver's name should be less than 50 characters";
  }
  return true;
};

export const validateDutyStartTime = (value, context) => {
  if (!value) {
    return `${DRIVER_FORM_ENTITIES.DUTY_START} ${TIME_IS_REQUIRED}`;
  }
  if (!HHMM_TIME_FORMAT.test(value)) {
    return INVALID_SHORT_TIME_FORMAT;
  }
  const { dutyEndTime, plannedDepartTime, plannedReturnTime, selectedVehicle } =
    context || {};
  if (dutyEndTime && selectedVehicle?.maxDutyTime) {
    const maxDutyTimeMinutes = selectedVehicle.maxDutyTime / 60;
    const dutyTimeMinutes = getDiffInMinutes(dutyEndTime, value);

    if (dutyTimeMinutes > maxDutyTimeMinutes) {
      const maxDutyTimeHours = maxDutyTimeMinutes / 60;
      return `Duty time cannot exceed ${maxDutyTimeHours.toFixed(1)} hours`;
    }
  } else if (dutyEndTime && getDiffInMinutes(dutyEndTime, value) > 690) {
    return 'Duty time cannot exceed 11.5 hours';
  }
  if (dutyEndTime && getDiffInMinutes(value, dutyEndTime) >= 0) {
    return 'Duty start must be before duty end';
  }
  if (plannedDepartTime && getDiffInMinutes(value, plannedDepartTime) >= 0) {
    return 'Duty start must be before depart time';
  }
  if (plannedReturnTime && getDiffInMinutes(value, plannedReturnTime) >= 0) {
    return 'Duty start must be before return time';
  }

  return true;
};

export const validateDutyEndTime = (value, context) => {
  if (!value) {
    return `${DRIVER_FORM_ENTITIES.DUTY_END} ${TIME_IS_REQUIRED}`;
  }
  if (!HHMM_TIME_FORMAT.test(value)) {
    return INVALID_SHORT_TIME_FORMAT;
  }
  const { dutyStartTime, plannedDepartTime, plannedReturnTime } = context || {};
  if (dutyStartTime && getDiffInMinutes(dutyStartTime, value) >= 0) {
    return 'Duty end must be after duty start';
  }
  if (plannedDepartTime && getDiffInMinutes(plannedDepartTime, value) >= 0) {
    return 'Duty end must be after depart time';
  }
  if (plannedReturnTime && getDiffInMinutes(plannedReturnTime, value) >= 0) {
    return 'Duty end must be after return time';
  }
  return true;
};

export const validatePlannedDepartTime = (value, context) => {
  if (!value) {
    return `${DRIVER_FORM_ENTITIES.DEPART} ${TIME_IS_REQUIRED}`;
  }
  if (!HHMM_TIME_FORMAT.test(value)) {
    return INVALID_SHORT_TIME_FORMAT;
  }
  const { dutyStartTime, plannedReturnTime, dutyEndTime } = context || {};
  if (dutyStartTime && getDiffInMinutes(dutyStartTime, value) >= 0) {
    return 'Depart time must be after duty start';
  }
  if (plannedReturnTime && getDiffInMinutes(value, plannedReturnTime) >= 0) {
    return 'Depart time must be before return time';
  }
  if (dutyEndTime && getDiffInMinutes(value, dutyEndTime) >= 0) {
    return 'Depart time must be before duty end time';
  }
  return true;
};

export const validatePlannedReturnTime = (value, context) => {
  if (!value) {
    return `${DRIVER_FORM_ENTITIES.RETURN} ${TIME_IS_REQUIRED}`;
  }
  if (!HHMM_TIME_FORMAT.test(value)) {
    return INVALID_SHORT_TIME_FORMAT;
  }
  const { dutyStartTime, plannedDepartTime, dutyEndTime } = context || {};
  if (dutyStartTime && getDiffInMinutes(dutyStartTime, value) >= 0) {
    return 'Return time must be after duty start';
  }
  if (plannedDepartTime && getDiffInMinutes(plannedDepartTime, value) >= 0) {
    return 'Return time must be after depart time';
  }
  if (dutyEndTime && getDiffInMinutes(value, dutyEndTime) >= 0) {
    return 'Return time must be before duty end time';
  }
  return true;
};

export const validateDeliveryStopTime = (value) => {
  if (!value) {
    return `${DRIVER_FORM_ENTITIES.DELIVERY_STOP} ${TIME_IS_REQUIRED}`;
  }
  if (isInvalidStopTime(value)) {
    return INVALID_SHORT_TIME_FORMAT;
  }
  return true;
};

export const validateCollectionStopTime = (value) => {
  if (!value) {
    return `${DRIVER_FORM_ENTITIES.COLLECTION_STOP} ${TIME_IS_REQUIRED}`;
  }
  if (isInvalidStopTime(value)) {
    return INVALID_SHORT_TIME_FORMAT;
  }
  return true;
};

export const validateVehicleTypeCode = (value) => {
  if (!value) {
    return `${DRIVER_FORM_ENTITIES.VEHICLE_TYPE} ${IS_REQUIRED}`;
  }
  return true;
};

export const validateDriverSectionCode = (value) => {
  if (!value) {
    return `${DRIVER_FORM_ENTITIES.SECTION} ${IS_REQUIRED}`;
  }
  return true;
};

export const validateSectionCode = (value, context) => {
  if (context.driverCode) {
    return validateDriverSectionCode(value);
  }
  return true;
};
